module.exports = __webpack_public_path__ + "static/media/filter-category.da3926a4.png";